import { getProactiveDraftsStore } from "../store/store";
import type CopilotTelemetrySession from "owa-copilot-telemetry/lib/CopilotTelemetrySession";

export function getItemProactiveDraftsTelemetrySession(itemId: string | undefined): CopilotTelemetrySession | undefined {
    if (!itemId) {
        return undefined;
    }
    const proactiveDrafts = getProactiveDraftsStore().proactiveDraftsListMap.get(itemId);
    if (proactiveDrafts) {
        return proactiveDrafts.itemTelemetrySession;
    }
    return undefined;
}
